<template>
	<div class="ss-breadcrumb" v-if="breadcrumbList.length">
		<div class="ss-container">
			<div class="ss-breadcrumb__menu">
				<div class="ss-breadcrumb__item" v-for="(item, index) in breadcrumbList" :key="index">
					<router-link v-if="item.to" :to="{name: item.to}">{{item.menuName}}</router-link>
					<span v-else class="ss-breadcrumb__item">{{item.menuName}}</span>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import {
		findByName
	} from '@/router/menuOperation.js'
	export default {
		name: 'Main',
		data() {
			return {
				breadcrumbList: []//面包屑导航
			}
		},
		watch: {
			'$route.path': {
				handler: function(val){
					let { level = 2, mode = 0 } = this.$route.meta || {};
					if(level > 2 || mode > 2 || mode === 'black'){
						this.breadcrumbList = findByName(this.$route);
					}else{
						this.breadcrumbList = [];
					}
				},
				deep: true,
				immediate: true
			}
		}
	}
</script>

<style lang="scss" scoped="scoped">
	.ss-breadcrumb{
		.ss-breadcrumb__menu{
			padding: 18px 0;
			.ss-breadcrumb__item{
				line-height: 40px;
				height: 40px;
				display: inline-block;
				font-size:16px;
				font-weight:400;
				color: #A2A3A2;
				a{
					text-decoration: none;
					color: #414141;
				}
				& + .ss-breadcrumb__item::before{
					content: "/ ";
					padding: 0 5px;
				}
			}
		}
	}
</style>
